/* Newsletter signup tracking: pushes GA4 events into the GTM dataLayer */
(function () {
  'use strict';

  var SOURCE_KEY = 'fg_newsletter_source';
  var SENT_KEY = 'fg_newsletter_signup_sent';
  var SOURCE_TTL = 5 * 60 * 1000;

  window.dataLayer = window.dataLayer || [];

  var queue = [];
  var popupSubmitted = {};
  var popupShown = {};

  /* Cookiebot marks statistics consent only after the user accepts, so hold events until then */
  function hasConsent() {
    if (typeof window.Cookiebot === 'undefined' || !window.Cookiebot.consent) return false;
    return window.Cookiebot.consent.statistics === true;
  }

  function push(payload) {
    if (!hasConsent()) {
      queue.push(payload);
      return;
    }
    flushQueue();
    window.dataLayer.push(payload);
  }

  function flushQueue() {
    if (!hasConsent()) return;
    while (queue.length) {
      window.dataLayer.push(queue.shift());
    }
  }

  window.addEventListener('CookiebotOnAccept', flushQueue);
  window.addEventListener('CookiebotOnConsentReady', flushQueue);

  /* consent can also be restored without firing a Cookiebot event, so poll for a short while */
  var consentPoll = setInterval(function () {
    if (hasConsent()) {
      flushQueue();
      clearInterval(consentPoll);
    }
  }, 1000);

  setTimeout(function () {
    clearInterval(consentPoll);
  }, 60000);

  /* sessionStorage throws in private mode, so every access stays guarded */
  function safeGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      /* source is lost across the redirect, the signup falls back to unknown */
    }
  }

  function rememberSource(location) {
    safeSet(SOURCE_KEY, JSON.stringify({ location: location, at: Date.now() }));
  }

  function readSource() {
    var raw = safeGet(SOURCE_KEY);
    if (!raw) return null;

    try {
      sessionStorage.removeItem(SOURCE_KEY);
    } catch (e) {
      /* keeping a stale source is harmless, it expires by TTL */
    }

    try {
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.at > SOURCE_TTL) return null;
      return parsed.location;
    } catch (e) {
      return null;
    }
  }

  function trackSubmits() {
    document.querySelectorAll('form[data-newsletter-location]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var location = form.getAttribute('data-newsletter-location');
        rememberSource(location);
        popupSubmitted[location] = true;
      });
    });
  }

  /* Shopify reloads the page with ?customer_posted=true, and every customer form on the page
     reports success, so the submitting form is only known from the stored source */
  function trackResult() {
    if (document.querySelector('[data-newsletter-result="success"]')) {
      var source = readSource();

      /* reloading the success URL must not count as a second signup */
      if (!source && safeGet(SENT_KEY) === location.href) return;
      safeSet(SENT_KEY, location.href);

      push({
        event: 'newsletter_signup',
        signup_location: source || 'unknown'
      });
      return;
    }

    var failed = document.querySelector('[data-newsletter-result="error"]');

    if (failed) {
      var form = failed.closest('form[data-newsletter-location]');

      push({
        event: 'newsletter_signup_error',
        signup_location: readSource() || (form && form.getAttribute('data-newsletter-location')) || 'unknown',
        error_reason: failed.getAttribute('data-newsletter-reason') || 'unknown'
      });
    }
  }

  function trackPopups() {
    document.querySelectorAll('.modal[data-popup-type][data-newsletter-popup]').forEach(function (modal) {
      var location = modal.getAttribute('data-newsletter-popup');

      /* the popup can already be open when a delayed script boots */
      if (modal.getAttribute('aria-hidden') === 'false') {
        popupShown[location] = true;
        push({ event: 'newsletter_popup_shown', signup_location: location });
      }

      new MutationObserver(function () {
        var open = modal.getAttribute('aria-hidden') === 'false';

        if (open && !popupShown[location]) {
          popupShown[location] = true;
          push({ event: 'newsletter_popup_shown', signup_location: location });
          return;
        }

        if (!open && popupShown[location] && !popupSubmitted[location]) {
          popupShown[location] = false;
          push({ event: 'newsletter_popup_dismissed', signup_location: location });
        }
      }).observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function init() {
    trackSubmits();
    trackPopups();
    trackResult();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
